import { action, makeObservable, observable } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';

import { getWidgetToken } from '../utils/get-widget-instance-id';
import { ErrorMessages, ErrorStatus, ExceptionStore } from './exception.store';

@injectable()
export class AuthStore {
    isAuthenticated = false;
    widgetToken?: string;

    constructor(@inject(ExceptionStore) private exceptionStore: ExceptionStore) {
        makeObservable(this, {
            isAuthenticated: observable,
            widgetToken: observable,
            setIsAuthenticated: action,
            setWidgetToken: action,
        });
    }

    setIsAuthenticated = (state: boolean) => (this.isAuthenticated = state);
    setWidgetToken = (token: string) => (this.widgetToken = token);

    init = (window: Window, search: string) => {
        if (window.self === window.top) {
            this.exceptionStore.stashError({
                logger: true,
                statusText: ErrorMessages.FieldLoadPage,
                statusCode: ErrorStatus.BADPAYLOAD,
            });

            return;
        }

        const widgetToken = getWidgetToken(search);

        if (!widgetToken) {
            this.exceptionStore.stashError({
                logger: true,
                statusText: ErrorMessages.InstanceNotProvided,
                statusCode: ErrorStatus.BADPAYLOAD,
            });

            return;
        }

        try {
            this.setIsAuthenticated(true);
            this.setWidgetToken(widgetToken);
        } catch (error) {
            this.exceptionStore.stashError(
                {
                    statusText: ErrorMessages.UnableInit,
                    statusCode: ErrorStatus.UNKNOWN,
                },
                error
            );
        }
    };
}
